import FlipCard from '@components/FlipCard'
import { Holding } from '@hooks/useHoldings'
import { getName } from '@utils/explorer'
import { memo, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import HoldingCard, { CopyReferralButton, StakeButton } from '../HoldingCard'
import { AirclawEmailSubmit } from './AirclawEmailSubmit'
import { DewiWorldEmailSubmit } from './DewiWorldEmailSubmit'

type DashboardSectionProps = {
  holding: Holding
  ripple?: boolean
}

const DashboardSection = ({ ripple, holding }: DashboardSectionProps) => {
  const { t } = useTranslation()

  const traits = useMemo(
    () => (
      <div className="grid grid-cols-2 gap-2">
        {holding &&
          Object.entries(holding?.attribute).map(([trait, value], index) => (
            <div
              key={index}
              className="py-2 px-3 flex gap-2 text-xs xs:text-sm justify-between items-center border border-solid rounded-sm bg-[rgb(35,38,42)] border-[rgb(53,59,64)]"
            >
              <span className="text-gray-500 text-xs">
                {/* Turn this into a translation function */}
                {getName(trait)}
              </span>
              {/* Turn this into a translation function */}
              <span className="text-[white] text-sm text-ellipsis whitespace-nowrap overflow-hidden">
                {value}
              </span>
            </div>
          ))}
      </div>
    ),
    [holding],
  )

  const TraitCard = () => {
    return (
      <div className="flex flex-col h-full items-center md:items-start gap-4 border border-[rgb(55,57,62)] rounded-md p-4">
        <div className="h-fit text-[white] text-lg text-center w-fit font-medium">
          {t('holdings.details.traits')}
        </div>
        {traits}
      </div>
    )
  }
  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
      <div className="flex flex-col gap-4 items-center w-full">
        <FlipCard
          frontContent={<HoldingCard ripple={ripple} holding={holding} />}
          backContent={<TraitCard />}
        />
        <div className="flex flex-col flex-wrap justify-center md:justify-start gap-2 h-fit items-center">
          <CopyReferralButton holding={holding} />
          <StakeButton holding={holding} />
        </div>
      </div>
      <div className="flex flex-col w-full flex-1 justify-center items-center gap-8 h-full">
        <DewiWorldEmailSubmit />
        <AirclawEmailSubmit
          imageURL={holding.imageURL}
          nftAddress={holding.publicKey.toBase58()}
        />
      </div>
    </div>
  )
}

export default memo(DashboardSection)
